import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
        },
        searchInputGroup: {
            width: '100%',
            maxWidth: remCalc(570),
            sx: {
                '> div': {
                    width: '100%',
                    marginLeft: '0',
                    marginRight: '0',
                },
                '> div > div': {
                    background: 'transparent',
                    border: '0',
                    borderRadius: '0',
                    boxShadow: 'none',
                    minHeight: remCalc(52),
                    paddingX: '0',
                    paddingY: '0',
                },
                '> div > div:hover': {
                    background: 'transparent',
                },
                '> div > div:focus-within': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '[data-testid="placeholder-label"]': {
                    display: 'none',
                },
                '[data-testid="input-component"]': {
                    paddingX: '0',
                    paddingY: '0',
                    height: remCalc(52),
                    textStyle: 'body-xxlarge',
                    fontWeight: 'light',
                    color: 'foreground.neutral.default',
                    lineHeight: '1.2',
                },
                '[data-testid="input-component"]::placeholder': {
                    color: 'foreground.neutral.subtle',
                    opacity: 1,
                },
            },
        },
        searchInput: {
            h: remCalc(64),
            py: remCalc(19),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.neutral.subtle',
            textStyle: 'body-xxlarge',
            fontWeight: 'light',
            color: 'foreground.neutral.subtle',
            height: 'medium.lg',
            _focus: {
                border: ' large',
                boxShadow: 'none',
            },
        },
        helpTextGap: {
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(24),
        },
        searchSuggestions: {
            flexDir: 'column',
            padding: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            justifyContent: 'center',
            alignItems: 'center',
        },
        searchInputPlaceholder: {
            color: 'text.secondary',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        inputClearButton: {
            appearance: 'none',
            display: 'none',
        },
        buttonModalStack: {
            alignItems: 'flex-start',
            gap: remCalc(10),
            flexWrap: 'wrap',
        },
        modalOverlay: {background: 'background.overlay-modal'},
        modalHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingY: '0',
            paddingX: {base: 'small.base', md: '0'},
        },
        modalContent: {
            maxWidth: '100%',
            paddingBottom: ['xsmall.base', 'xsmall.sm', 'medium.md', 'medium.lg'],
            paddingInline: ['xsmall.base', 'xsmall.sm', 'medium.md', 'unset'],
            gap: ['small-1.base', 'small-1.sm', 'small-1.md', 'small-1.lg'],
            background: 'background.base.default',
            margin: '0',
            borderRadius: {base: 0, lg: 'large.lg'},
            maxHeight: '100%',
            minHeight: {base: '100%', lg: 'auto'},
            boxSizing: 'border-box',
        },
        modalBody: {
            display: 'flex',
            flexDirection: 'column',
            gap: ['small-1.base', 'small-1.sm', 'small-1.md', 'small-1.lg'],
        },
        quickLinksStack: {
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
        },
        trendingStack: {
            gap: 'xxsmall.base',
        },
        quickLinksTitle: {
            textStyle: 'body-xsmall',
            color: 'foreground.neutral.subtle',
            py: ['xxxsmall. base', 'xxxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
        },
        suggestionsTitle: {
            textStyle: 'body-xsmall',
            fontWeight: 'medium',
            color: 'foreground.neutral.subtle',
            py: 'xxxsmall.base',
        },
        productImage: {
            boxSize: {base: remCalc(141), lg: remCalc(109)},
            minW: {lg: remCalc(109)},
            marginX: 'auto',
        },
        productGrid: {
            overflowY: 'scroll',
            height: 'fit-content',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
        },
        scrollContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'xsmall.base',
            maxHeight: '100%',
            overflowY: 'auto',
        },
        productDetails: {
            flexDirection: {base: 'column', lg: 'row'},
            gap: 'small.base',
            paddingRight: remCalc(12),
            borderRight: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        productName: {
            color: 'text.default',
            textStyle: 'head-xsmall',
            fontWeight: 'medium',
        },
        pricingAlignment: {
            textAlign: {base: 'start', lg: 'end'},
            gap: {base: 'xxsmall.base', lg: remCalc(12)},
        },
        productdGrid: {
            templateColumns: {
                base: `repeat(3, ${remCalc(332)})`,
                md: `repeat(3, minmax(${remCalc(310)}, 42vw))`,
                lg: 'repeat(3, minmax(0, 1fr))',
                xl: 'repeat(3, minmax(0, 1fr))',
            },
            gap: {base: 'xsmall-1.base', md: 'xsmall-1.lg'},
            overflowX: 'visible',
            overflowY: 'visible',
            width: {base: 'max-content', lg: '100%'},
        },
        productsTitleButton: {
            gap: 'xxsmall.lg',
            width: '100%',
            minW: 0,
        },
        productSearchTileWrapper: {
            width: '100%',
            height: '100%',
        },
        defaultStateLayout: {
            display: 'grid',
            gridTemplateColumns: {base: '1fr', xl: 'repeat(4, minmax(0, 1fr))'},
            gap: {base: 'small-1.base', xl: 'small-1.xl'},
            alignItems: {base: 'start', xl: 'stretch'},
        },
        defaultStateMainColumn: {
            transition: 'min-height 220ms ease',
            width: '100%',
            minW: 0,
            gridColumn: {xl: '2 / span 3'},
            paddingRight: {xl: remCalc(1)},
        },
        defaultStateSideColumn: {
            display: 'flex',
            flexDirection: 'column',
            alignSelf: {xl: 'stretch'},
            minH: {xl: remCalc(320)},
            gap: {base: 'small.base', xl: 'small.lg'},
            width: {base: '100%', lg: remCalc(240), xl: 'auto'},
            maxW: {base: '100%', lg: remCalc(240), xl: 'none'},
            minW: 0,
            gridColumn: {xl: '1 / span 1'},
        },
        defaultQuickLinksWrap: {
            width: '100%',
            mt: {base: 0, xl: 'auto'},
        },
        curatedSkeletonCard: {
            gap: 'xsmall.base',
        },
        curatedSkeletonImage: {
            height: {base: remCalc(141), lg: remCalc(109)},
            width: '100%',
            borderRadius: 'small.base',
        },
        curatedSkeletonTitle: {
            height: remCalc(18),
            width: '70%',
        },
        curatedSkeletonPrice: {
            height: remCalc(14),
            width: '40%',
        },
        namePricing: {
            gap: 'xsmall.base',
        },
        closeIcon: {
            boxSize: remCalc(16),
            color: 'foreground.neutral.default',
        },
        logo: {
            width: {base: `${remCalc(109)}`, lg: `${remCalc(120)}`},
            height: {base: `${remCalc(36)}`, lg: `${remCalc(56)}`},
            cursor: 'pointer',
        },
        rightElement: {
            cursor: 'pointer',
            height: '100%',
            svg: {
                boxSize: remCalc(16),
                color: 'foreground.neutral.default',
            },
        },
        popoverContent: {
            width: '100%',
            // maxWidth: remCalc(570),
        },
        spellingMessageGap: {
            pt: remCalc(2),
        },
        searchSurfaceShell: {
            position: 'fixed',
            left: '0',
            right: '0',
            bottom: '0',
            background: 'background.base.overlay',
            zIndex: 'modal',
            pointerEvents: 'none',
            overflow: 'hidden',
        },
        searchSurfaceRow: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            background: 'background.base.default',
            maxHeight: '100%',
        },
        searchSurfacePanel: {
            pointerEvents: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 'small-1.base',
            flex: '1 0 0',
            borderRadius: '0',
            overflowY: 'auto',
            overflowX: 'hidden',
            margin: '0',
            width: '100%',
            maxWidth: {base: '100%', '2xl': remCalc(1432)},
            maxHeight: '100%',
            button: {
                cursor: 'pointer',
            },
            '[role="button"]': {
                cursor: 'pointer',
            },
            a: {
                cursor: 'pointer',
            },
        },
        searchSurfaceInner: {w: '100%'},
        modalHeaderActionButton: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSize: remCalc(28),
            minW: remCalc(28),
            color: 'foreground.neutral.default',
            cursor: 'pointer',
        },
        searchInputRow: {
            width: '100%',
            alignItems: 'center',
            gap: remCalc(16),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.neutral.subtle',
            paddingBottom: '0',
            minHeight: remCalc(54),
        },
        searchInputGrow: {
            flex: 1,
            minW: 0,
        },
        quickLinksListItem: {
            lineHeight: 'normal',
            listStyleType: 'none',
            borderBottom: 'none',
            textDecoration: 'none',
        },
        quickLinksList: {
            alignItems: 'flex-start',
            gap: 'xxsmall.base',
            listStyleType: 'none',
            margin: 0,
            padding: 0,
        },
        quickLinkButton: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: 'xxsmall.base',
            py: 'xxxsmall.base',
            px: '0',
            minHeight: 'unset',
            borderBottom: 'none',
            textDecoration: 'none',
            backgroundImage: 'none',
        },
        quickLinkIcon: {
            color: 'foreground.neutral.default',
            boxSize: remCalc(12),
            flexShrink: 0,
        },
        quickLinkText: {
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
        activeStateContainer: {
            position: 'relative',
        },
        activeStateLayout: {
            display: 'grid',
            gridTemplateColumns: {base: '1fr', xl: 'repeat(4, minmax(0, 1fr))'},
            gap: {base: 'medium.base', xl: 'medium.lg'},
            alignItems: {base: 'start', xl: 'stretch'},
        },
        activeStateSideColumn: {
            display: 'flex',
            flexDirection: 'column',
            gap: {base: 'medium.base', xl: 'small.lg'},
            order: {base: 1, xl: 1},
            width: {base: '100%', lg: remCalc(240), xl: 'auto'},
            maxW: {base: '100%', lg: remCalc(240), xl: 'none'},
            minW: 0,
            gridColumn: {xl: '1 / span 1'},
            gridRow: {xl: '1'},
        },
        activeQuickLinksWrap: {
            mt: {base: 0, xl: 'auto'},
            width: '100%',
        },
        activeStateMainColumn: {
            order: {base: 2, xl: 2},
            width: '100%',
            minW: 0,
            gridColumn: {xl: '2 / span 3'},
            gridRow: {xl: '1'},
            paddingRight: {xl: remCalc(1)},
        },
        productGridScrollArea: {
            width: {
                base: `calc(100% + ${remCalc(24)})`,
                md: `calc(100% + ${remCalc(24)})`,
                lg: '100%',
            },
            marginInline: {base: remCalc(-12), md: remCalc(-32), lg: 0},
            paddingInlineStart: {base: remCalc(12), md: remCalc(12), lg: 0},
            paddingBlock: {base: 'micro.base', md: 'micro.md', lg: 0},
            boxSizing: 'border-box',
            overflowX: {base: 'auto', lg: 'visible'},
            overflowY: 'visible',
            paddingRight: {base: 'small.base', md: 'small.lg', xl: 0},
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
        },
        activeSuggestionsList: {
            alignItems: 'flex-start',
            gap: 'xxsmall.base',
            width: '100%',
            minW: 0,
        },
        activeSuggestionButton: {
            justifyContent: 'flex-start',
            width: 'fit-content',
            minW: 0,
            px: '0',
            py: 'xxxsmall.base',
            minHeight: 'unset',
            textAlign: 'left',
            textDecoration: 'none',
        },
        activeSuggestionText: {
            textStyle: 'body-xxlarge',
            fontWeight: 'light',
            lineHeight: remCalc(26),
            width: '100%',
            minW: 0,
            noOfLines: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
        topResultsRow: {
            width: '100%',
            minW: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        topResultsTitle: {
            textStyle: 'body-xsmall',
            fontWeight: 'medium',
            color: 'foreground.neutral.subtle',
            py: 'xxxsmall.base',
        },
        topResultsAction: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: remCalc(4),
            px: '0',
            py: '0',
            minHeight: 'unset',
            backgroundImage: 'none',
            textDecoration: 'none',
        },
        topResultsActionText: {
            textStyle: 'body-xsmall',
            fontWeight: 'medium',
        },
        topResultsActionIcon: {
            boxSize: remCalc(12),
            color: 'currentColor',
            flexShrink: 0,
        },
        zeroResultsStack: {
            gap: ['small-1.base', 'small-1.sm', 'small-1.md', 'small-1.lg'],
        },
        zeroResultsMessage: {
            textStyle: {base: 'body-medium', lg: 'body-xxlarge'},
            color: 'foreground.neutral.subtle',
            fontWeight: 'light',
            py: ['xxxsmall.base', 'xxxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
        },
        searchLoadingOverlay: {
            position: 'absolute',
            inset: 0,
            background: 'background.base.default',
            opacity: 0.9,
            pointerEvents: 'none',
            borderRadius: 'small.base',
            p: {base: 'small.base', lg: 'small.lg'},
        },
        searchLoadingSkeletonGrid: {
            display: 'grid',
            gridTemplateColumns: {base: '1fr', md: 'repeat(2, 1fr)', xl: 'repeat(3, 1fr)'},
            gap: {base: 'small.base', md: 'small.lg'},
        },
        searchLoadingSkeletonItem: {
            height: remCalc(220),
            borderRadius: 'small.base',
        },
        suggestionContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
        },
        suggestionIcon: {
            boxSize: remCalc(14),
            marginRight: remCalc(4),
            flexShrink: 0,
        },
    },
    variants: {
        productSearch: {
            searchInputGroup: {
                maxWidth: 'unset',
            },
            container: {
                width: '100%',
            },
        },
        modalSearch: {
            searchInputGroup: {
                maxWidth: 'unset',
            },
            searchSuggestions: {
                position: 'absolute',
                background: 'background.base.default',
                w: '100%',
                padding: '0',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.secondary',
                alignItems: 'flex-start',
                maxHeight: remCalc(160),
                overflowY: 'auto',
                overflowX: 'hidden',
                zIndex: 'dropdown',
                justifyContent: 'flex-start',
                sx: {
                    '&::-webkit-scrollbar': {
                        width: remCalc(6),
                    },
                    '&::-webkit-scrollbar-track': {
                        borderRadius: 'medium.base',
                        background: 'background.light',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        borderRadius: remCalc(6.5),
                        background: 'button.border.inverse-primary-focused',
                    },
                },
            },
            suggestionText: {
                textStyle: 'body-xxlarge',
                fontWeight: 'light',
                color: 'foreground.neutral.muted',
            },
            suggestionButton: {
                padding: `${remCalc(4)} 0`,
                color: 'foreground.neutral.muted',
                justifyContent: 'flex-start',
                fontWeight: 'light',
                minHeight: 'unset',
                textDecoration: 'none',
                backgroundImage: 'none',
                sx: {
                    '&:not(:last-child)': {
                        borderBottom: 'none',
                    },
                    '&:hover': {
                        bg: 'transparent',
                        color: 'foreground.neutral.default',
                        fontWeight: 'light',
                    },
                    '&:focus-visible': {
                        bg: 'transparent',
                        color: 'foreground.neutral.default',
                        fontWeight: 'light',
                        boxShadow: 'outline',
                    },
                },
            },
            suggestionsContainer: {
                marginX: 0,
                width: '100%',
                flexDirection: 'column',
            },
            searchHStack: {
                padding: `${remCalc(8)} 0`,
            },
            modalSuggestions: {
                position: 'absolute',
                background: 'white',
                top: '100%',
                left: '0',
                width: '100%',
                zIndex: 'popover',
                height: 'auto',
                tabIndex: '-1',
                maxHeight: remCalc(160),
                justifyContent: 'center',
                alignItems: 'center',
            },
            popoverContent: {
                width: 'full',
                border: 'unset',
                marginTop: remCalc(-8),
            },
        },
        faqSearch: {
            container: {
                maxWidth: remCalc(570),
            },
            spellingMessageGap: {
                pt: remCalc(24),
            },
        },
        manualsSearch: {
            searchInputGroup: {
                maxWidth: 'unset',
                height: remCalc(44),
                minHeight: remCalc(44),
                bg: 'background.base.elevated',
                border: '1px solid var(--chakra-colors-border-neutral-highlight)',
                borderRadius: 'large-1',
                boxShadow:
                    '0 0 0 1px var(--border-neutral-highlight, #FFF) inset, 0 1px 2px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 0 0 1px var(--neutral-xs, rgba(19, 24, 58, 0.08))',
                overflow: 'hidden',
                sx: {
                    '> div[data-testid="search-right-element"]': {
                        width: 'auto',
                        marginLeft: 'unset',
                        marginRight: 'unset',
                    },
                    '> div:not([data-testid="search-right-element"])': {
                        width: '100%',
                        marginLeft: '0',
                        marginRight: '0',
                    },
                    '> div:not([data-testid="search-right-element"]) > div': {
                        background: 'transparent',
                        border: '0',
                        borderRadius: '0',
                        boxShadow: 'none',
                        minHeight: remCalc(44),
                        height: remCalc(44),
                        paddingLeft: remCalc(16),
                        paddingRight: remCalc(52),
                        paddingTop: '0',
                        paddingBottom: '0',
                    },
                    '> div:not([data-testid="search-right-element"]) > div:hover': {
                        background: 'transparent',
                    },
                    '> div:not([data-testid="search-right-element"]) > div:focus-within': {
                        background: 'transparent',
                        boxShadow: 'none',
                    },
                    '[data-testid="placeholder-label"]': {
                        display: 'none',
                    },
                    '[data-testid="input-component"]': {
                        paddingX: '0',
                        paddingY: '0',
                        height: remCalc(44),
                        textStyle: 'body-small',
                        fontWeight: 'regular',
                        color: 'background.neutral.bronze',
                        lineHeight: '1.2',
                    },
                    '[data-testid="input-component"]::placeholder': {
                        color: 'background.neutral.bronze',
                        opacity: 1,
                    },
                },
            },
            rightElement: {
                height: '100%',
                right: remCalc(16),
                width: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'foreground.neutral.default',
                pointerEvents: 'auto',
                svg: {
                    boxSize: remCalc(20),
                    color: 'foreground.neutral.default',
                },
            },
            modalSuggestions: {
                position: 'absolute',
                background: 'white',
                top: '100%',
                left: '0',
                width: '100%',
                zIndex: 'popover',
                height: 'auto',
                tabIndex: '-1',
                maxHeight: remCalc(160),
                justifyContent: 'center',
                alignItems: 'center',
            },
            popoverContent: {
                width: 'full',
                border: 'unset',
                marginTop: remCalc(8),
            },
        },
    },
    parts: [
        'container',
        'searchInputGroup',
        'searchInput',
        'searchSuggestions',
        'searchInputPlaceholder',
        'searchHStack',
        'modalSuggestions',
        'suggestionsContainer',
        'suggestionButton',
        'suggestionText',
        'suggestionIcon',
        'inputClearButton',
        'buttonModalStack',
        'modalOverlay',
        'modalHeader',
        'modalContent',
        'modalBody',
        'quickLinksStack',
        'trendingStack',
        'quickLinksTitle',
        'suggestionsTitle',
        'productImage',
        'productGrid',
        'scrollContainer',
        'productDetails',
        'productName',
        'pricingAlignment',
        'productdGrid',
        'productsTitleButton',
        'defaultStateLayout',
        'defaultStateMainColumn',
        'defaultStateSideColumn',
        'defaultQuickLinksWrap',
        'curatedSkeletonCard',
        'curatedSkeletonImage',
        'curatedSkeletonTitle',
        'curatedSkeletonPrice',
        'namePricing',
        'closeIcon',
        'logo',
        'rightElement',
        'popoverContent',
        'spellingMessageGap',
        'searchTriggerButton',
        'searchSurfaceShell',
        'searchSurfacePanel',
        'searchSurfaceInner',
        'modalHeaderActionButton',
        'searchInputRow',
        'searchInputGrow',
        'quickLinksListItem',
        'quickLinksList',
        'quickLinkButton',
        'quickLinkIcon',
        'quickLinkText',
        'activeStateContainer',
        'activeStateLayout',
        'activeStateSideColumn',
        'activeQuickLinksWrap',
        'activeStateMainColumn',
        'productGridScrollArea',
        'activeSuggestionsList',
        'activeSuggestionButton',
        'activeSuggestionText',
        'topResultsRow',
        'topResultsTitle',
        'topResultsAction',
        'topResultsActionText',
        'topResultsActionIcon',
        'zeroResultsStack',
        'zeroResultsMessage',
        'searchLoadingOverlay',
        'searchLoadingSkeletonGrid',
        'searchLoadingSkeletonItem',
    ],
}
